import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Icon } from "@iconify/react";
import CustomerStatsSection from "./CustomerStatsSection";
import { useState } from "react";
import CustomerDetailTabSection from "./CustomerDetailTabSection";
import CustomerDetailFooter from "./CustomerDetailFooter";
import CustomerDetailContentSection from "./CustomerDetailContentSection";
import CustomerOfficeIdModal from "./CustomerOfficeIdModal";
import { URLdecode, URLencode } from "../../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  right: "0%",
  transform: "translate(0%, -50%)",
  width: window.innerWidth > 600 ? "80vw" : "100vw",
  bgcolor: "background.paper",
  boxShadow: 24,
};

export default function CustomerDetailModal({ open, setOpen, data, callback }) {
  const params = URLdecode();
  const [tab, setTab] = useState("profile");
  const [officeIdOpen, setOfficeIdOpen] = useState(false);
  const [wallets, setWallets] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
    if (params?.order) {
      navigate(
        `${location.pathname}?${URLencode({ ...params, order: null })}`,
        { replace: true },
      );
    }
  };

  const handleOpenOfficeId = () => {
    handleClose();
    setOfficeIdOpen(true);
  };

  return (
    <>
      <CustomerOfficeIdModal
        open={officeIdOpen}
        setOpen={setOfficeIdOpen}
        data={data}
      />
      <Modal
        open={data?._id === params?.order || open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex flex-col font-main h-screen max-w-[100vw]">
            <div className="w-full max-w-[100vw] bg-primary1 p-4 text-white font-semibold flex justify-between">
              <span>{data?.detail?.agencyName}</span>
              <button onClick={() => handleClose()}>
                <Icon
                  icon="material-symbols:close"
                  className={`text-secondary text-3xl`}
                />
              </button>
            </div>
            <div className="flex flex-1 flex-col overflow-y-scroll scroll-hide relative">
              <CustomerStatsSection
                data={data}
                open={open}
                wallets={wallets}
                setWallets={setWallets}
              />
              <CustomerDetailTabSection
                selected={tab}
                onTabSelect={(tb) => setTab(tb)}
              />
              <CustomerDetailContentSection
                tab={tab}
                data={data}
                callback={callback}
              />
              <div className="flex-1"></div>
              <CustomerDetailFooter
                data={data}
                callback={callback}
                wallets={wallets}
                onOpenOfficeId={handleOpenOfficeId}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
